module.exports = __webpack_public_path__ + "img/usdttrc20.33081760.svg";